export const breakpoints = ['1200px', '1920px']

export default {
  breakpoints,
}
